import Marquee from "react-fast-marquee";
import { VENTURES } from "../../data/ventures";

const ITEMS = [
  "AI Employees",
  "Autonomous Trading",
  "Enterprise SaaS",
  "Gold Scalping EA",
  "Food Like Heaven",
  "Built for Success",
];

export const MarqueeStrip = () => (
  <section id="marquee" data-testid="marquee-section" className="relative py-16 md:py-20">
    <div className="divider-glow mx-auto max-w-[1440px]" />
    <div className="py-10 [mask-image:linear-gradient(90deg,transparent,#000_12%,#000_88%,transparent)]">
      <Marquee speed={32} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-4xl font-extrabold uppercase tracking-tight text-outline sm:text-6xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-cyan-400/60" />
          </div>
        ))}
      </Marquee>
      <div className="mt-6">
        <Marquee speed={22} gradient={false} autoFill direction="right">
          {VENTURES.map((v) => (
            <div key={v.id} className="mx-6 flex items-center gap-6">
              <span className="font-mono-tech text-sm font-medium uppercase tracking-[0.3em] text-slate-500">
                {v.name}
              </span>
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: v.accent }} />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
    <div className="divider-glow mx-auto max-w-[1440px]" />
  </section>
);
